import React, { FC } from "react";

import { InvoiceUserType } from "../../types/InvoiceTypes";
import { InvoiceList } from "./InvoiceList";

type Props = {
  userIs: InvoiceUserType;
};

export const InvoiceListPage: FC<Props> = ({ userIs }) => {
  return (
    <div>
      <InvoiceList userIs={userIs} />
    </div>
  );
};
